import { Card, CardContent, Divider } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react'

import { useLocation, useHistory } from 'react-router-dom';
import { AuthContext } from '../../context/Globales/AuthContext';
import UserContext from '../../context/Globales/UserContext';
import { types } from '../../context/types';

//Aqui Recibiremos los parametros y accionaremos la llamada a la api que estara en el contextAPI

const LoginDisable = (Autenticado) => {
    //localStorage.clear();
    
    const location = useLocation();

    const userContext = useContext(UserContext);
    const { dispatch } = useContext(AuthContext);
        
        const query = new URLSearchParams(location.search);
        const prdd = query.get("PRD");
        const skll = query.get("SKL");
        localStorage.setItem("skll", JSON.stringify(skll));
        const [login, setLogin] = useState({
            user: '',
            pass: ''
        });

    
    const { user, pass } = login;



        //if (skll) {
           useEffect(() => {

            userContext.LoginTwo(skll, prdd);
            if (skll) {
            
                localStorage.setItem("autenticadoTwo", JSON.stringify(true));
    
            }else{
                localStorage.setItem("autenticadoTwo", JSON.stringify(false));
            }
            
           }, [skll, prdd]);

        
       
        setTimeout(() => {

            // userContext.getLogin(user, pass)// desde aqui se genera la cadena de sucesos en donde se llama a las 3 apis de login
        
            
                dispatch({
                     type: types.AuthLogin,
                   payload: { name: user },
//
               })

            
            

         //   window.location.href = "/";
        // localStorage.setItem("autenticadoTwo", JSON.stringify(false));

        }, 1500);
           


      //  }else{
      //      //window.location.href = "/login";
      //  }

            
           
        
       

    return (
        <div style={{ textAlign: 'center', alignContent: 'center', padding: '150px', width:'100%' }}>
        <Card>
            <CardContent>
            <img src={process.env.PUBLIC_URL + '/static/imagen/200.gif'} alt="Loading carga" tile="loading carga espera!"  ></img>
            <br />
            <h1>Espere un momento estamos procesando tu solicitud...</h1>
            <Divider />
            <p></p>
           
          
            </CardContent>
            
        </Card>
         
     </div>
    )
}
export default LoginDisable;